var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_782_8488)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.875 6.5C3.875 4.22183 5.72183 2.375 8 2.375C10.2782 2.375 12.125 4.22183 12.125 6.5C12.125 8.718 11.008 10.7795 9.80645 12.3415C9.21344 13.1124 8.61893 13.7368 8.17311 14.1678C8.11242 14.2264 8.05459 14.2814 8 14.3326C7.94541 14.2814 7.88758 14.2264 7.82689 14.1678C7.38107 13.7368 6.78656 13.1124 6.19355 12.3415C4.99198 10.7795 3.875 8.718 3.875 6.5ZM7.45293 16.1829C7.45317 16.1831 7.45339 16.1833 8 15.5L7.45339 16.1833C7.77296 16.4389 8.22704 16.4389 8.54661 16.1833L8 15.5C8.54661 16.1833 8.54683 16.1831 8.54707 16.1829L8.54765 16.1824L8.54915 16.1812L8.55352 16.1777L8.56759 16.1663C8.57931 16.1567 8.59565 16.1433 8.61631 16.1261C8.65763 16.0916 8.71625 16.042 8.7897 15.978C8.93653 15.8501 9.14306 15.6641 9.38939 15.426C9.88107 14.9507 10.5366 14.2626 11.1935 13.4085C12.492 11.7205 13.875 9.282 13.875 6.5C13.875 3.25533 11.2447 0.625 8 0.625C4.75533 0.625 2.125 3.25533 2.125 6.5C2.125 9.282 3.50802 11.7205 4.80645 13.4085C5.46344 14.2626 6.11893 14.9507 6.61061 15.426C6.85694 15.6641 7.06347 15.8501 7.2103 15.978C7.28375 16.042 7.34237 16.0916 7.38369 16.1261C7.40435 16.1433 7.42069 16.1567 7.43241 16.1663L7.44648 16.1777L7.45085 16.1812L7.45235 16.1824L7.45293 16.1829ZM6 6.5C6 5.39543 6.89543 4.5 8 4.5C9.10457 4.5 10 5.39543 10 6.5C10 7.60457 9.10457 8.5 8 8.5C6.89543 8.5 6 7.60457 6 6.5Z",
    fill: "#171C1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_8488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.7b31f10c22f6a99c3134193bfa29e200.svg";
export { ForwardRef as ReactComponent };